/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Dashboard',
    slug: 'home',
    icon: 'HomeIcon'
  },
  {
    header: 'Main menu',
    icon: 'ArchiveIcon',
    items: [
      {
        name: 'Projects & Samples',
        slug: 'projects-samples',
        icon: 'ArchiveIcon',
        group_permissions: ['view-project-brief' ,'create-project-brief', 'view-sample-order', 'create-sample-order'],
        submenu: [
          {
            url: '/pages/customer-project-briefs',
            name: 'Project Brief',
            slug: '',
            icon: 'BriefcaseIcon',
            permissions: ['view-project-brief' ,'create-project-brief'],
          },
          {
            url: '/pages/customer-sample-orders',
            name: 'Sample Orders',
            slug: 'page-sample-orders',
            icon: 'ShoppingCartIcon',
            permissions: ['view-sample-order', 'create-sample-order'],
          },
        ]
      },
    ]
  },
  {
    name: 'My Account',
    slug: 'my-account',
    icon: 'UserIcon',
    group_permissions: ['view-customer', 'edit-customer', 'view-user', 'create-user', 'view-site', 'create-site', 'view-account-credit'],
    submenu: [
      {
        url: '/pages/customer-profile',
        name: 'Customer Profile',
        slug: 'customer-profile',
        icon: 'UsersIcon',
        permissions: ['view-customer', 'edit-customer'],
      },
      {
        url: '/pages/supplier-user',
        name: 'Customer Users',
        slug: 'supplier-user',
        icon: 'UsersIcon',
        permissions: ['view-user', 'create-user'],
      },
      {
        url: '/pages/customer-sites',
        name: 'Customer Sites',
        slug: 'customer-sites',
        icon: 'BoxIcon',
        permissions: ['view-site', 'create-site'],
      },
      {
        url: '/pages/customer-account-credit',
        name: 'Account Credit',
        slug: 'account-credit',
        icon: 'DollarSignIcon',
        permissions: ['view-account-credit'],
      },
    ]
  },
  {
    name: 'Manage Orders',
    slug: 'Order-from-catalogue',
    icon: 'BoxIcon',
    group_permissions: ['view-product-contract', 'view-order','create-order', 'view-sales-quote', 'view-credit-note'],
    submenu: [
      {
        url: '/pages/customer-product-contracts',
        name: 'Product Contracts',
        slug: 'manage-product-contracts',
        icon: 'TriangleIcon',
        permissions: ['view-product-contract'],
      },
      {
        url: '/pages/customer-product-orders',
        name: 'Product Orders',
        slug: 'page-product-orders',
        icon: 'BoxCartIcon',
        permissions: ['view-order','create-order'],
      },
      {
        url: '/pages/invoices',
        name: 'SO Invoices',
        slug: 'invoice-manage',
        icon: 'BoxCartIcon',
        permissions: ['view-invoice'],
      },
      {
        url: '/pages/sales-quotes',
        name: 'Sales Quotes',
        slug: 'sales-quotes',
        icon: 'BoxCartIcon',
        permissions: ['view-sales-quote'],
      },
      {
        url: '/pages/credit-notes',
        name: 'Credit Notes',
        slug: 'credit-notes',
        icon: 'BoxCartIcon',
        permissions: ['view-credit-note'],
      },
      // {
      //   url: '/pages/product-catalogue',
      //   name: 'Product Catalogue',
      //   slug: 'product-catalogue',
      //   icon: 'BoxCartIcon'
      // }
    ]
  },
]
